<template>
  <v-dialog
    v-model="eventPartnersDialog"
    transition="dialog-bottom-transition"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="80%"
    scrollable
  >
    <v-card>
      <v-toolbar
        dark
        flat
        color="secondary"
        scrollable
      >
        <v-btn
          icon
          dark
          @click.native="eventPartnersDialog = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>ספקים</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <advanced-table
          :headers="headers"
          :filters="filters"
          :sortBy="'callFirst'"
          :descending="true"
          :resource="resource"
          :optionLists="optionLists"
          :doNotSaveState="true"
          :hideExternalToolbar="true"
          :rowAction="addPartner"
          :defaultRowsPerPage="5"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { format } from "date-fns";
import { getApi } from "@/api";
import generateId from "@/idGenerator";
import AdvancedTable from "@/components/AdvancedTable.vue";
import { setTimeout } from "timers";

export default {
  data() {
    return {
      adding: {},
      removing: {},
      headers: [
        {
          text: "שם",
          value: "name",
          align: "right",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            return data[key] || "ללא שם";
          }
        },
        {
          text: "תאריך יצירה",
          value: "created",
          align: "right",
          visible: false,
          displayFunc: (data, key) => {
            return format(data[key], "DD-MM-YYYY");
          }
        },
        {
          text: "סוגים",
          value: "types",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            let field = "title";
            let p = {};
            let array = data[key];
            if (Array.isArray(array) && array.length) {
              return array
                .map(item => {
                  return this.entityById("partnerTypes", item)[field];
                })
                .reduce((p, v) => p + ", " + v);
            }
            return "";
          }
        },
        {
          text: "מדינות",
          value: "countries",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            let field = "name";
            let p = {};
            let array = data[key];
            if (Array.isArray(array) && array.length) {
              return array
                .map(item => {
                  let country = this.entityById("countries", item);
                  return country ? country[field] : "ללא שם";
                })
                .reduce((p, v) => p + ", " + v);
            }
            return "";
          }
        },
        {
          text: "איזורים",
          value: "regions",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            let field = "name";
            let p = {};
            let array = data[key];
            if (Array.isArray(array) && array.length) {
              return array
                .map(item => {
                  return this.entityById("regions", item)[field];
                })
                .reduce((p, v) => p + ", " + v);
            }
            return "כל האיזורים";
          }
        },
        {
          text: "תאריך אימות פרטים",
          value: "lastValidation",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            return format(data[key], "DD-MM-YYYY");
          }
        },
        {
          text: "סוג הקשר",
          value: "relationship",
          align: "right",
          visible: false,
          displayFunc: (data, key) => {
            let relationship = this.entityById(
              "partnerRelationships",
              data[key]
            );
            return relationship ? relationship.title : "לא ידוע";
          }
        },
        {
          text: "מומלץ",
          value: "recommended",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] ? "כן" : "לא";
          }
        },
        {
          text: "מומלץ",
          value: "recommended",
          align: "right",
          visible: true,
          type: 'ICON',
          displayFunc: (data, key) => {
            return data[key] ? { icon: 'star', color: 'orange' } : { icon: 'mdi-star-outline', color: 'gray' };
          }
        },
        {
          text: "להתקשר ראשון",
          value: "callFirst",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] ? "כן" : "לא";
          }
        },
        {
          text: "הוספה לאירוע",
          type: "ACTION",
          value: "action",
          name: "addPartnerToEvent",
          align: "left",
          visible: true,
          icon: "add",
          click: partnerId => {
            return this.addPartner(partnerId);
          }
        }
      ],
      filters: [
        {
          type: "COMBOBOX",
          label: "מדינות",
          model: "countries",
          items: "countries",
          itemText: "name",
          itemValue: "_id",
          active: true
        },
        {
          type: "COMBOBOX",
          label: "סוגי ספקים",
          model: "types",
          items: "types",
          itemText: "titlePlural",
          itemValue: "_id",
          active: true
        },
        {
          type: "DATE",
          label: "נוצר אחרי",
          model: "createdAfter",
          active: false
        },
        {
          type: "DATE",
          label: "נוצר לפני",
          model: "createdBefore",
          active: false
        },
        {
          type: "DATE",
          label: "אימות פרטים לפני",
          model: "lastValidationBefore",
          active: false
        },
        {
          type: "TEXT",
          label: "חיפוש חופשי",
          model: "search",
          icon: "search",
          expanded: true,
          active: true
        }
      ]
    };
  },

  computed: {
    eventPartnersDialog: {
      get() {
        return this.$store.getters["events/eventPartnersDialog"];
      },
      set(isActive) {
        this.$store.commit("events/TOGGLE_EVENT_PARTNERS_DIALOG", isActive);
      }
    },
    eventId() {
      return this.$route.params.id;
    },
    partners() {
      return this.$store.getters["entityList"]("partners");
    },
    relationships() {
      return this.$store.getters["entityList"]("partnerRelationships");
    },
    types() {
      return this.$store.getters["entityList"]("partnerTypes");
    },
    countries() {
      return this.$store.getters["entityList"]("countries").filter(item => {
        return item.isActive;
      });
    },
    resource() {
      return this.$store.state.resources["partner"];
    },
    optionLists() {
      return {
        relationships: this.relationships,
        types: this.types,
        countries: this.countries
      };
    }
  },

  methods: {
    format,
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    },
    addPartner(partnerId) {
      return new Promise((resolve, reject) => {
        // Check if we're in כולם mode (multiple events)
        const partnersForAllEvents = this.$store.getters["events/partnersForAllEvents"];
        const isAllEventsMode = partnersForAllEvents && partnersForAllEvents.length > 1;

        if (isAllEventsMode) {
          // Add partner to all events in the ARAN
          console.log('EventPartnersDialog addPartner - adding to all events:', partnersForAllEvents);
          
          let promises = partnersForAllEvents.map(eventId => {
            return getApi()
              .then(api => {
                let params = {
                  partnerId
                };
                return api.patch(`/events/${eventId}/add-partner`, params);
              });
          });
          
          Promise.all(promises)
            .then(() => {
              this.$store.dispatch("SHOW_SNACKBAR", {
                text: 'ספק התווסף לכל האירועים בהצלחה',
                color: "success"
              });
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        } else {
          // Add partner to single event (normal mode)
          getApi()
            .then(api => {
              let params = {
                partnerId
              };
              return api.patch(`/events/${this.eventId}/add-partner`, params);
            })
            .then(() => {
              this.$store.dispatch("SHOW_SNACKBAR", {
                text: 'ספק התווסף בהצלחה',
                color: "success"
              });
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    }
  },

  beforeMount() {},

  mounted() {},

  watch: {
    // eventPartnersDialog: {
    //   handler: function(val) {
    //     if (!val) {
    //       this.reset();
    //     } else {
    //       this.fetch();
    //     }
    //   },
    //   immediate: true
    // }
  },

  components: {
    AdvancedTable
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/events/EventPartnersDialog.vue